export default function Footer() {
  return (
    <footer className="bg-dark text-light text-center flex-shrink-0 py-1">
      <small className="text-light text-opacity-50">
        Outrights Demo {new Date().getFullYear()}
      </small>
    </footer>
  );
}
